import { Component } from '@angular/core';

@Component({
  selector: 'app-form-range-demo',
  templateUrl: './form-range-demo.component.html',
})
export class FormRangeDemoComponent {}
